import { post, get, put, deleteApi } from './axiosFun';

// 错题集 分页
export const mistakesPage = (params) => { return post("/edu/mistakes-collection/page", params) };
// 错题集 详情
export const mistakesDetails = (mistakesCollectionId) => { return get(`edu/mistakes-collection/detail/${mistakesCollectionId}`) };
// 错题集 删除
export const mistakesRemove = (params) => { return deleteApi("/edu/mistakes-collection/remove", params) };



// WEBPACK FOOTER //
// ./src/api/mistakes.js